"use client";

import { useEffect } from "react";
import { reloadIfNewBuild } from "@/lib/new-build";

/**
 * Any server action a page calls after a deploy (Approve on a card, Skip, a save) fails when the
 * page came from the build before: that failure reloads the page onto the new build, once, with
 * what was typed in its boxes kept. Renders nothing.
 */
export function NewBuildReload(): null {
  useEffect(() => {
    const onRejection = (event: PromiseRejectionEvent) => {
      if (reloadIfNewBuild(event.reason)) event.preventDefault();
    };
    const onError = (event: ErrorEvent) => {
      if (reloadIfNewBuild(event.error)) event.preventDefault();
    };
    window.addEventListener("unhandledrejection", onRejection);
    window.addEventListener("error", onError);
    return () => {
      window.removeEventListener("unhandledrejection", onRejection);
      window.removeEventListener("error", onError);
    };
  }, []);
  return null;
}
